// Package Imports
import { toJS } from "mobx";

// Project Imports
import OptimizationStore from "../../store/OptimizationStore";
import AuthStore from "../../../login/store/AuthStore";
import changeLaApiCall from "../change-la/changeLaApiCall";
import * as APITypes from "constants/API";

const updateAddAssuredFamilyProductId = async (apiRequest, familyProductIdData, needType) => {
  let productListData = toJS(OptimizationStore.product_list_data);
  let needList = AuthStore.needMasterList;

  let isselectedNeed = needList.some((item) => item.unique_name == needType);

  productListData.map((item) => {
    item.data.forEach((value) => {
      if (
        value.life_assured_details.id === apiRequest.family_member_id &&
        isselectedNeed && !value.hasOwnProperty("family_product_id")
      ) {
        value.family_product_id = familyProductIdData.family_product_details_id;
      }
    });
    return item;
  });
  OptimizationStore.product_list_data = [...productListData];
  changeLaApiCall(familyProductIdData, needType, APITypes.ADD_NEW_LA)
};

export default updateAddAssuredFamilyProductId;
